import FormHandler from '../../forms/FormHandler';
import { Country, State } from '../../forms/address/types';
import StateFilteredAddress from '../../forms/address/StateFilteredAddress';
import AnalyticsService from '../../analytics/AnalyticsService';
import { IViewItemAnalytics, IViewItemAnalyticsItem } from '../../analytics/types';
import fireAddToCartAnalytics from '../../analytics/fireAddToCartAnalytics';

interface PageConfig {
  stateFilterData: { states: State[]; countries: Country[]; };
  viewItemAnalytics: IViewItemAnalytics;
  ga4DatalayerItems?: IViewItemAnalyticsItem[];
}

window.tnew.page.initialize = ({ stateFilterData, viewItemAnalytics, ga4DatalayerItems }: PageConfig) => {
  if (viewItemAnalytics) {
    AnalyticsService.trackViewItem(viewItemAnalytics);
  }

  AnalyticsService.pushEcommerceItems(ga4DatalayerItems ?? []);

  const $form = document.querySelector('#tn-contribution-form') as HTMLFormElement;

  const formHandler = new FormHandler($form, {
    onValidationSuccess: () => {
      const amountInput = $form.querySelector<HTMLInputElement>('[name="AddContribution.Amount"]');
      const amount = parseFloat(amountInput?.value || '0') || 0;

      fireAddToCartAnalytics(viewItemAnalytics, [{ price: amount, quantity: 1, itemVariant: '' }]);

      $form.submit();
    },
  });

  StateFilteredAddress.createForCustomFormFields($form, formHandler, stateFilterData);
};
